<template>
    <g>
        <path
            d="M14.3646 5.23412L12.9597 2.99143C12.8341 2.79011 12.6112 2.66672 12.373 2.66672H3.62741C3.38929 2.66672 3.16632 2.79011 3.04076 2.99143L1.63583 5.23412C0.910638 6.39227 1.55357 8.00285 2.90871 8.18686C3.00613 8.19985 3.1057 8.20634 3.20528 8.20634C3.84605 8.20634 4.41322 7.92492 4.80288 7.4898C5.19253 7.92492 5.76187 8.20634 6.40047 8.20634C7.04124 8.20634 7.60841 7.92492 7.99806 7.4898C8.38772 7.92492 8.95705 8.20634 9.59566 8.20634C10.2364 8.20634 10.8036 7.92492 11.1933 7.4898C11.5851 7.92492 12.1522 8.20634 12.7908 8.20634C12.8926 8.20634 12.99 8.19985 13.0874 8.18686C14.4469 8.00502 15.092 6.39444 14.3646 5.23412ZM12.7952 8.90123C12.5787 8.90123 12.3644 8.86876 12.1566 8.81897V10.9794H3.84389V8.81897C3.63607 8.86659 3.42176 8.90123 3.20528 8.90123C3.0754 8.90123 2.94335 8.89257 2.81563 8.87525C2.6944 8.85793 2.57534 8.82979 2.46061 8.79732V13.0576C2.46061 13.4407 2.77017 13.7503 3.15333 13.7503H12.8515C13.2346 13.7503 13.5442 13.4407 13.5442 13.0576V8.79732C13.4273 8.83196 13.3104 8.8601 13.1892 8.87525C13.0571 8.89257 12.9272 8.90123 12.7952 8.90123Z"
            :fill="iconFill"
        />
    </g>
</template>
<script>
export default {
    name: "OutletOut1616",
    props: {
        iconFill: {
            type: String,
            default: "#C8D0DD",
        },
    },
};
</script>
